<template>
  <div>
    <div class="subtitle-2 font-weight-bold mt-4 mb-1">Review notes <span class="caption grey--text">(private to admins)</span></div>

    <v-textarea v-model="draft" label="Add a note" rows="2" auto-grow counter="5000" dense outlined hide-details="auto" />
    <div class="d-flex align-center mt-1">
      <v-checkbox v-model="attachAi" :disabled="!ai" label="Attach current AI summary" dense hide-details class="mt-0" />
      <v-spacer />
      <v-btn small color="primary" class="text-none" :loading="saving" :disabled="!draft.trim()" @click="save">Add note</v-btn>
    </div>

    <v-progress-linear v-if="loading" indeterminate class="mt-2" />
    <v-alert v-else-if="error" type="error" dense outlined class="mt-2">{{ error }}
      <v-btn small text @click="load">Retry</v-btn>
    </v-alert>
    <div v-else-if="!notes.length" class="caption grey--text mt-2">No notes yet.</div>

    <v-card v-for="n in notes" :key="n.id" outlined class="pa-2 mt-2">
      <div class="d-flex align-center caption grey--text">
        <span>{{ n.author || 'Unknown' }} · {{ formatDate(n.created_at) }}<span v-if="n.period_from"> · {{ n.period_from }} → {{ n.period_to }}</span></span>
        <v-spacer />
        <v-btn icon x-small @click="remove(n)"><v-icon small>mdi-delete-outline</v-icon></v-btn>
      </div>
      <div class="body-2" style="white-space:pre-wrap">{{ n.body }}</div>
      <div v-if="n.ai_summary" class="caption mt-1">
        <v-chip x-small color="purple" dark class="mr-1">AI summary</v-chip>{{ n.ai_summary.summary }}
      </div>
    </v-card>
  </div>
</template>

<script>
import { getNotes, addNote, deleteNote } from '@/services/adminGrowthService'

export default {
  name: 'AdminNotesSection',
  props: {
    userId: { type: Number, required: true },
    range: { type: Object, required: true },
    ai: { type: Object, default: null },
  },
  data() {
    return { notes: [], loading: false, error: null, draft: '', attachAi: false, saving: false }
  },
  watch: {
    userId() { this.draft = ''; this.attachAi = false; this.notes = []; this.load() },
    ai(v) { if (!v) this.attachAi = false },
  },
  created() { this.reqId = 0 },
  mounted() { this.load() },
  methods: {
    formatDate(d) { return d ? String(d).slice(0, 10) : '' },
    async load() {
      const id = ++this.reqId
      this.loading = true; this.error = null
      try {
        const data = await getNotes(this.userId)
        if (id === this.reqId) this.notes = data || []
      } catch (e) {
        if (id === this.reqId) this.error = e.message
      } finally {
        if (id === this.reqId) this.loading = false
      }
    },
    async save() {
      this.saving = true
      const uid = this.userId
      try {
        const allTime = this.range.from === 'all'
        await addNote({
          user_id: uid,
          body: this.draft.trim(),
          period_from: allTime ? null : this.range.from,
          period_to: allTime ? null : this.range.to,
          ai_summary: this.attachAi && this.ai ? this.ai : null,
        })
        this.$toast.success('Note added')
        if (this.userId === uid) {
          this.draft = ''
          this.attachAi = false
          await this.load()
        }
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        this.saving = false
      }
    },
    async remove(note) {
      if (!window.confirm('Delete this note?')) return
      try {
        await deleteNote(note.id)
        this.$toast.success('Note deleted')
        await this.load()
      } catch (e) {
        this.$toast.error(e.message)
      }
    },
  },
}
</script>
